<template>
  <main-template>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col>
            <h1>
              <v-btn id="btn-go-back" color="primary" x-small text @click="goBack">
                <v-icon left> fa fa-angle-left </v-icon>
              </v-btn>
              Aulas
            </h1>
          </v-col>
        </v-row>
        <v-card v-if="gestaoDeAula">
          <v-card-text>
            <v-row style="color: black">
              <v-col cols="12">
                <h4 id="turma-descricao">
                  Turma: {{ gestaoDeAula?.turma ? gestaoDeAula?.turma.descricao : "- - -" }}
                </h4>
                <h4 id="disciplina-descricao">
                  Disciplina{{
                    gestaoDeAula.disciplina?.descricao
                      ? ": " + gestaoDeAula.disciplina?.descricao
                      : "s: "
                  }}
                  <div v-for="(item, index) in gestaoDeAula.disciplinas" :key="index">
                    <v-chip
                      :id="`chip-disciplina-${index}`"
                      color="orange"
                      dark
                      class="ml-2"
                      x-small
                      >{{ item.descricao }}
                    </v-chip>
                  </div>
                </h4>
                <h4 id="carga-horaria">
                  Carga horária:
                  {{
                    gestaoDeAula.carga_horaria
                      ? gestaoDeAula.carga_horaria
                      : "[ SEM CARGA HORÁRIA ]"
                  }}
                </h4>
                <div>
                  <v-row>
                    <v-col cols="5">
                      <h4 id="professor-nome">
                        Professor {{ parseInt(gestaoDeAula.is_hp, 10) == 1 ? "HP" : "" }}:
                        {{ gestaoDeAula.professor?.nome ?? "[Professor não encontrado]" }}
                      </h4>
                    </v-col>
                    <v-col cols="6">
                      <v-avatar id="avatar-professor" color="indigo" size="25" class="ms-3">
                        <v-icon dark> mdi-account-circle </v-icon>
                      </v-avatar>
                      <v-chip
                        id="chip-aulas-confirmadas"
                        class="ms-3"
                        small
                        color="primary darken-2"
                      >
                        Aulas confirmadas: {{ total_de_aulas_confirmadas_do_prof_efetivo }}
                      </v-chip>
                      <v-chip
                        id="chip-aulas-aguardando"
                        class="ms-3"
                        small
                        color="primary lighten-1"
                      >
                        Aulas aguardando confirmação:
                        {{ total_de_aulas_aguardando_confirmacao_do_prof_efetivo }}
                      </v-chip>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="py-2">
                <v-btn-toggle id="btn-toggle-actions" borderless>
                  <v-btn id="btn-frequencia" value="left" @click="() => openModalMonth(1)">
                    <span class="hidden-sm-and-down">Frequência</span>
                    <v-icon right> mdi-file-pdf </v-icon>
                  </v-btn>

                  <v-btn id="btn-aulas" value="center" @click="() => openModalMonth(2)">
                    <span class="hidden-sm-and-down">Aulas</span>

                    <v-icon right> mdi-file-pdf </v-icon>
                  </v-btn>
                  <v-btn
                    id="btn-notas"
                    v-if="!gestaoDeAula?.turma.isInfantil"
                    value="right"
                    @click="() => diarioNotas()"
                  >
                    <span class="hidden-sm-and-down">Notas</span>

                    <v-icon right> mdi-file-pdf </v-icon>
                  </v-btn>

                  <v-btn
                    id="btn-diario-bncc"
                    v-if="gestaoDeAula?.turma.isInfantil"
                    value="right"
                    @click="() => RelatorioBNCCTurma()"
                  >
                    <span class="hidden-sm-and-down">Relatório bncc</span>

                    <v-icon right> mdi-file-pdf </v-icon>
                  </v-btn>

                  <v-btn id="btn-historico-aulas" value="right" @click="() => verHistoricoAulas()">
                    <span class="hidden-sm-and-down">Histórico de aulas</span>

                    <v-icon right> mdi-poll </v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-col
          cols="12"
          class="pt-3 px-0 mt-3"
          v-if="
            !user.role.name.includes('assistente-social') &&
            !user.role.name.includes('psicologo(a)')
          "
        >
          <div
            id="div-criar-aula"
            v-if="$route.query.is_infantil_multi === 'true'"
            class="d-flex justify-space-between"
          >
            <div>
              <v-btn
                id="btn-criar-aula-infantil"
                color="success"
                @click="() => criarAulaInfantil(gestaoDeAula)"
                class="mr-2"
                >Criar Aula Infantil</v-btn
              >
            </div>
          </div>
          <div id="div-criar-aula-pesquisar" v-else class="d-flex justify-space-between">
            <div v-if="gestaoDeAula?.is_polivalencia">
              <v-btn
                id="btn-criar-aula-polivalencia"
                color="success"
                @click="() => criarAulaPolivalencia(gestaoDeAula)"
                class="mr-2"
                >Criar Aula</v-btn
              >
            </div>
            <div v-else>
              <v-btn
                id="btn-criar-aula"
                color="success"
                @click="() => criarAula(gestaoDeAula)"
                class="mr-2"
                >Criar Aula</v-btn
              >
            </div>
            <v-text-field
              id="input-pesquisar"
              v-model="search"
              class="ml-2 search-input"
              append-icon="mdi-magnify"
              label="Pesquisar..."
              solo
              autofocus
              dense
              single-line
              hide-details
            />
          </div>
        </v-col>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-data-table
          id="data-table-aulas"
          :headers="table.headers"
          :items="aulasList"
          :loading="carregandoAulas"
          :items-per-page="10"
          :custom-filter="dataTableFilter"
          :search="search"
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr
                :id="`row-aula-${aula.id}`"
                color="primary"
                :class="aula.estaDeletado ? ['deleted'] : []"
                v-for="(aula, i) in items"
                :key="aula.id"
              >
                <td>{{ aula.id }}</td>
                <td>
                  {{ aula.data_formatada }}
                  <e-tooltip-exclusao :exclusoes="aula.exclusoes_count" />
                </td>

                <td id="col-situacao" class="d-flex align-center">
                  <e-situacao-aula :aula="aula" :i="i" @alterarSituacao="alterarSituacao" />
                  <v-chip
                    :id="`chip-situacao-${aula.id}`"
                    class="ml-2"
                    v-if="aula.descricaoSituacao === 'Aula em conflito'"
                    color="orange"
                    x-small
                    dark
                    @click="() => verificaSituacao(aula.id)"
                  >
                    ?</v-chip
                  >
                </td>

                <td id="col-tipo"><e-tipo-aula-snippet :aula="aula" /></td>
                <td id="col-horarios">
                  <v-list-group no-action sub-group>
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>Visualizar Horários</v-list-item-title>
                      </v-list-item-content>
                    </template>

                    <v-list-item v-for="(title, i) in getHorariosDaAula(aula)" :key="i" link>
                      <li :id="`horario-${i}`">{{ title?.descricao }}</li>
                    </v-list-item>
                  </v-list-group>
                </td>
                <td>
                  <div class="d-flex align-center">
                    <v-icon
                      :color="
                        aula.presencas_confirmadas === null
                          ? 'grey'
                          : aula.presencas_confirmadas
                          ? 'green'
                          : 'orange'
                      "
                    >
                      {{
                        aula.presencas_confirmadas === null
                          ? "mdi-help-circle"
                          : aula.presencas_confirmadas
                          ? "mdi-check"
                          : "mdi-clock-outline"
                      }}
                    </v-icon>
                    <span
                      class="ml-1 text-uppercase"
                      :class="
                        aula.presencas_confirmadas === null
                          ? 'grey--text'
                          : aula.presencas_confirmadas
                          ? 'green--text'
                          : 'orange--text'
                      "
                    >
                      {{
                        aula.presencas_confirmadas === null
                          ? "Não informada"
                          : aula.presencas_confirmadas
                          ? "Confirmada"
                          : "Pendente"
                      }}
                    </span>
                  </div>
                </td>

                <td id="col-acoes" width="25%" class="text-right">
                  <v-tooltip
                    id="tooltip-notifiq"
                    color="primary"
                    v-if="parseInt(gestaoDeAula?.turma.notifiq, 10) === 1"
                    bottom
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :id="`btn-notifiq-${aula.id}`"
                        x-small
                        class="ml-1"
                        :color="parseInt(aula.frequencia_notifiq, 10) === 1 ? 'primary' : 'info'"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => enableSubmit(aula)"
                      >
                        <span class="material-icons">
                          {{ parseInt(aula.frequencia_notifiq, 10) === 1 ? "link" : "link_off" }}
                        </span>
                      </v-btn>
                    </template>
                    <span
                      >{ parseInt(aula.frequencia_notifiq, 10) === 1 ? "Registro de presenca
                      automático" : "Registro de presenca manual" }</span
                    >
                  </v-tooltip>
                  <v-tooltip id="tooltip-visualizar" color="primary" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :id="`btn-visualizar-${aula.id}`"
                        x-small
                        class="ml-1"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => verMotivoAula(aula)"
                      >
                        <v-icon small>fa fa-eye </v-icon>
                      </v-btn>
                    </template>
                    <span>Visualizar aula </span>
                  </v-tooltip>
                  <v-tooltip
                    id="tooltip-lancar-frequencia"
                    v-if="
                      (!aula.estaDeletado && aula?.horarios_extras?.length > 0) || aula?.horario_id
                    "
                    color="green darken-2"
                    bottom
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :id="`btn-lancar-frequencia-${aula.id}`"
                        x-small
                        class="ml-1"
                        color="green darken-1"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="
                          (aula.descricaoSituacao !== 'Aguardando confirmação'
                            ? !$can(['aulas.atualizarAposDefinirSituacao'])
                            : false) ||
                          !aula.can_edit_aula ||
                          aula.presencas_confirmadas
                        "
                        @click="abrirModalConfirmacao(aula.id)"
                      >
                        <v-icon small white class="white--text">mdi-check-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>Confirmar Presença</span>
                  </v-tooltip>

                  <!-- Frequência Manual -->
                  <v-tooltip v-if="!aula.estaDeletado" color="blue darken-2" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="blue"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="
                          (aula.descricaoSituacao !== 'Aguardando confirmação'
                            ? !$can(['aulas.atualizarAposDefinirSituacao'])
                            : false) || !aula.can_edit_aula
                        "
                        :to="{
                          name: 'aulas.frequencia',
                          params: { gestaoDeAulaId, aula_id: aula.id },
                        }"
                      >
                        <v-icon small white class="white--text">mdi mdi-book-edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Frequência Manual</span>
                  </v-tooltip>
                  <v-tooltip id="tooltip-editar" v-if="!aula.estaDeletado" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :id="`btn-editar-${aula.id}`"
                        x-small
                        class="ml-1"
                        color="blue-grey lighten-3"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="
                          (aula.descricaoSituacao !== 'Aguardando confirmação' &&
                          aula.descricaoSituacao !== 'Aula em conflito'
                            ? true
                            : false) || !aula.can_edit_aula
                        "
                        @click="
                          () =>
                            aula.disciplina_id === null
                              ? editarAulaPolivalencia(aula, gestaoDeAula)
                              : editarAula(aula, gestaoDeAula)
                        "
                      >
                        <v-icon small>fa fa-edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar Aula</span>
                  </v-tooltip>
                  <v-tooltip id="tooltip-apagar" v-if="!aula.estaDeletado" color="error" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :id="`btn-apagar-${aula.id}`"
                        x-small
                        class="ml-1"
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="
                          (aula.descricaoSituacao !== 'Aguardando confirmação' &&
                          aula.descricaoSituacao !== 'Aula em conflito'
                            ? true
                            : false) || !aula.can_edit_aula
                        "
                        @click="() => deletarAula(aula)"
                      >
                        <v-icon small>fa fa-trash </v-icon>
                      </v-btn>
                    </template>
                    <span>Apagar Aula </span>
                  </v-tooltip>
                  <v-tooltip id="tooltip-recuperar" v-if="aula.estaDeletado" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :id="`btn-recuperar-${aula.id}`"
                        x-small
                        class="ml-1"
                        color="info"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => recuperarAula(aula)"
                      >
                        <v-icon small>fa fa-sync </v-icon>
                      </v-btn>
                    </template>
                    <span>Recuperar Aula </span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-bottom-sheet v-model="aulasEmConflitos" scrollable>
      <v-sheet class="text-center pa-md-8 mx-lg-auto" height="auto">
        <v-btn color="error" dark small @click="aulasEmConflitos = !aulasEmConflitos">
          Fechar
        </v-btn>

        <v-alert
          class="mt-2"
          style="text-align: center"
          type="orange"
          v-if="aulasConflitadasEncontradas"
        >
          Procurando aulas em conflitos
        </v-alert>

        <h2 class="mt-4">Aulas conflitadas</h2>
        <v-simple-table class="mt-4" style="border: 1px solid #e0e0e0">
          <template>
            <thead style="background-color: #e0e0e0">
              <tr>
                <th class="text-left">#</th>
                <th class="text-left">Professor</th>
                <th class="text-left">Situação</th>
                <th class="text-left">Data/Horario</th>
                <th class="text-left">Turma</th>
                <th class="text-left">Disciplina</th>
              </tr>
            </thead>
            <tbody class="text-left">
              <tr v-if="aulasConflitadas.length <= 0">
                <td>SEM AULAS EM CONFLITOS</td>
              </tr>
              <tr v-for="item in aulasConflitadas" :key="item.id">
                <td>{{ item.id }}</td>
                <td>
                  {{ item.professor?.nome ?? "[Professor não encontrado]" }}
                  <br />
                  <v-chip color="grey" dark x-small>
                    {{ item?.turma.franquia?.descricao }}
                  </v-chip>
                </td>
                <td>{{ item.situacao }}</td>
                <td>
                  <span>
                    {{ item.data.split("-").reverse().join("/") }}
                  </span>
                  - {{ item.horario?.descricao }}
                </td>
                <td>{{ item?.turma?.descricao }}</td>
                <td>{{ item.disciplina?.descricao }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-sheet>
    </v-bottom-sheet>
    <e-drawer-motivo-aula v-model="verMotivo" :aula="aula" :disciplina="gestaoDeAula?.disciplina">
    </e-drawer-motivo-aula>
    <e-drawer-historico-aulas v-model="openDrawer" :gestao_id="parseInt(gestaoDeAulaId, 10)">
    </e-drawer-historico-aulas>
    <!-- Dialog -->
    <e-modal-select-month-aula
      :dialog="dialog"
      @dialogChange="dialog = $event"
      :gestao_id="gestaoDeAulaId"
      :tipo_diario="tipo_diario"
      :tipoEnsino="ensinoType"
    ></e-modal-select-month-aula>

    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="removerRegistroPeloNotifiq"
    >
    </e-modal-confirm>
    <ModalConfirmacao
      v-model="showConfirmacaoModal"
      titulo="Confirmar Frequência"
      acao="confirmar a frequência desta aula"
      avisoTipo="warning"
      avisoIcon="mdi-alert-circle"
      avisoTexto="Todos alunos serão marcados como presentes"
      icon="mdi-account-check"
      icon-color="primary"
      texto-confirmar="Sim, Confirmar"
      cor-botao-confirmar="success"
      icone-botao-confirmar="mdi-check-circle"
      aviso-tipo="info"
      ref="modalConfirmacao"
      @confirmado="confirmarFrequencia"
    />
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import { dataTableFilter } from "@/plugins/searchQuery";
import Aula from "@/Models/Aula";
import ModalConfirmacao from "../../components/EModalConfirmacao.vue";

export default {
  props: {
    gestaoDeAulaId: {
      required: true,
      type: [String, Number],
    },
  },
  components: {
    ModalConfirmacao,
  },
  data() {
    return {
      aulasConflitadasEncontradas: false,
      aulasConflitadas: [],
      aulasEmConflitos: false,
      dataTableFilter,
      listagemAulas: [],
      aulasList: [],
      carregandoAulas: false,
      relatorio: [],
      gestaoDeAulas: null,
      aula_notifiq: null,
      confirmDialog: false,
      ensinoType: "fundamental",
      objectModal: {
        title: "Notifiq",
        message:
          "Essa aula está sendo rigistrada automaticamente pelo notifiq, deseja realmente deixar esse registro manual?",
      },
      verMotivo: false,
      dialog: false,
      openDrawer: false,
      tipo_diario: 0,
      aula: {},
      gestaoDeAula: null,
      search: "",
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Data", value: "data_formatada" },
          { text: "Situação", value: "situacao" },
          { text: "Tipo", value: "tipo" },
          { text: "Horário", value: "horario_descricao" },
          { text: "Confirmação de frequência", value: "presencas_confirmadas" },
          {
            text: "Ações",
            value: "actions",
            sortable: false,
            width: "200px",
          },
        ],
      },
      horariosAll: [],
      total_de_aulas_confirmadas_do_prof_efetivo: 0,
      total_de_aulas_aguardando_confirmacao_do_prof_efetivo: 0,
      professores_auxiliares: [],
      showConfirmacaoModal: false,
      aulaSelecionadaId: null,
      removerFaltas: false,
    };
  },
  async mounted() {
    await this.getHorariosAll();
    await this.loadData();
    if (this.$route.query.is_infantil_multi === "true") {
      this.ensinoType = "infantil";
    }
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
  },
  methods: {
    async getHorariosAll() {
      this.horariosAll = await this.$services.horariosService.horariosAll();
    },

    getHorariosDaAula(aula) {
      const horariosFiltrados = [];

      const horariosDaAulaExtra = JSON.parse(aula?.horarios_extras);

      if (horariosDaAulaExtra) {
        horariosDaAulaExtra.forEach((element) => {
          if (element.array) {
            element.array.forEach((idHorario) => {
              horariosFiltrados.push(this.horariosAll.filter((item) => item.id === idHorario)[0]);
            });
          }
        });
      }
      if (aula.horario) {
        horariosFiltrados.push(aula.horario);
      }

      return horariosFiltrados;
    },
    enableSubmit(aula = null) {
      this.confirmDialog = !this.confirmDialog;
      if (aula) {
        this.aula_notifiq = {
          ...aula,
          frequencia_notifiq: parseInt(aula.frequencia_notifiq, 10) === 1 ? 0 : 1,
          gestao_de_aula: parseInt(this.$route.params.gestaoDeAulaId, 10),
        };
        return;
      }
      this.aula_notifiq = aula;
    },
    goBack() {
      this.$router.push({ name: "gestoesDeAulas" });
    },
    async removerRegistroPeloNotifiq() {
      this.$loaderService.open("Carregando relátorio");
      try {
        if (this.aula_notifiq) {
          await this.$services.aulasService.atualizarRegistroNotifiq(this.aula_notifiq);
          await this.loadData();
          this.$set(this.listagemAulas, this.index_aula_notifiq, this.aula_notifiq);
        }
      } catch (error) {
        this.$loaderService.close();
        this.$handleError(error);
      }
      this.confirmDialog = !this.confirmDialog;
      this.$loaderService.close();
    },
    openModalMonth(tipo_diario) {
      this.dialog = true;
      this.tipo_diario = parseInt(tipo_diario, 10);
    },
    criarAulaPolivalencia(gestaoDeAula) {
      if (this.$route.query.is_infantil_multi === "false") {
        this.$router.push({
          name: "aulas.polivalencia.create",
          params: { gestaoDeAulaId: gestaoDeAula.id },
          query: { is_infantil_multi: "false" },
        });
      } else {
        this.$router.push({
          name: "aulas.polivalencia.create",
          params: { gestaoDeAulaId: gestaoDeAula.id },
        });
      }
    },
    criarAula(gestaoDeAula) {
      this.$router.push({
        name: gestaoDeAula?.turma.isInfantil ? "aulasInfantis.create" : "aulas.create",
        params: {
          gestaoDeAulaId: gestaoDeAula.id,
        },
        query: { is_infantil_multi: "false" },
      });
    },
    criarAulaInfantil(gestaoDeAula) {
      this.$router.push({
        name: "aulasInfantis.create",
        params: {
          gestaoDeAulaId: gestaoDeAula.id,
        },
        query: { is_infantil_multi: "true" },
      });
    },

    async diarioNotas() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.diarioNotas(this.gestaoDeAulaId);
        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    verMotivoAula(aula) {
      this.verMotivo = !this.verMotivo;
      this.aula = aula;
    },
    editarAula(aula, gestaoDeAula) {
      if (this.$route.query.is_infantil_multi === "true") {
        this.$router.push({
          name: "aulasInfantis.edit",
          params: {
            gestaoDeAulaId: aula.instrutorDisciplinaTurma_id,
            aula_id: aula.id,
          },
          query: { is_infantil_multi: "true" },
        });
      } else if (gestaoDeAula?.turma.isInfantil) {
        this.$router.push({
          name: "aulasInfantis.edit",
          params: {
            gestaoDeAulaId: aula.instrutorDisciplinaTurma_id,
            aula_id: aula.id,
          },
        });
      } else {
        this.$router.push({
          name: "aulas.edit",
          params: {
            gestaoDeAulaId: aula.instrutorDisciplinaTurma_id,
            aula_id: aula.id,
          },
        });
      }
    },

    editarAulaPolivalencia(aula) {
      if (this.$route.query.is_infantil_multi === "false") {
        this.$router.push({
          name: "aulas.polivalencia.edit",
          params: {
            gestaoDeAulaId: aula.instrutorDisciplinaTurma_id,
            aula_id: aula.id,
          },
          query: {
            is_infantil_multi: "false",
          },
        });
      } else if (this.$route.query.is_infantil_multi === "true") {
        this.$router.push({
          name: "aulasInfantis.edit",
          params: {
            gestaoDeAulaId: aula.instrutorDisciplinaTurma_id,
            aula_id: aula.id,
          },
          query: {
            is_infantil_multi: "true",
          },
        });
      } else {
        this.$router.push({
          name: "aulas.polivalencia.edit",
          params: {
            gestaoDeAulaId: aula.instrutorDisciplinaTurma_id,
            aula_id: aula.id,
          },
        });
      }
    },
    async alterarSituacao(Objeto) {
      this.$set(this.listagemAulas, Objeto.i, Objeto.aulaAtualizada);
      await this.loadData();
    },
    async verificaSituacao(aula_id) {
      this.aulasEmConflitos = !this.aulasEmConflitos;
      const data = await this.$services.aulasService.listarAulasEmConflitos(aula_id);
      this.aulasConflitadas = data.data;
      if (data.data.length === 0) {
        this.$services.aulasService.atualizarSituacaoDaAula(aula_id).then(() => {
          this.$forceUpdate();
          window.location.reload();
        });
      }
    },
    async loadData() {
      this.carregandoAulas = true;

      if (this.total_de_aulas_confirmadas_do_prof_efetivo !== 0) {
        this.total_de_aulas_confirmadas_do_prof_efetivo = 0;
      }

      if (this.total_de_aulas_aguardando_confirmacao_do_prof_efetivo !== 0) {
        this.total_de_aulas_aguardando_confirmacao_do_prof_efetivo = 0;
      }

      this.$loaderService.open("Carregando Aulas");
      try {
        const response = await this.$services.gestoesDeAulasService.listarAulasGestao(
          this.gestaoDeAulaId
        );

        this.listagemAulas = response.payload.gestaoDeAula.aulas.map((aula) => new Aula(aula));

        this.aulasList = response.aulas;

        if (this.listagemAulas.length > 0) {
          const aulas = this.listagemAulas?.map((aula) => {
            if (aula?.situacao === this.$constants.situacoesAulasTexto.confirmada) {
              this.total_de_aulas_confirmadas_do_prof_efetivo += 1;
            }
            if (
              aula?.situacao === this.$constants.situacoesAulasTexto.aguardando ||
              aula?.situacao === "" ||
              aula?.situacao === null
            ) {
              this.total_de_aulas_aguardando_confirmacao_do_prof_efetivo += 1;
            }
            return aula;
          });
        }

        const auxiliares = this.professores_auxiliares?.map((auxiliar_atual, index) => {
          if (
            typeof this.professores_auxiliares[index]
              .total_de_aulas_confirmadas_do_prof_auxiliar === "undefined"
          ) {
            this.professores_auxiliares[index].total_de_aulas_confirmadas_do_prof_auxiliar = 0;
          }
          if (
            typeof this.professores_auxiliares[index]
              .total_de_aulas_aguardando_confirmacao_do_prof_auxiliar === "undefined"
          ) {
            this.professores_auxiliares[
              index
            ].total_de_aulas_aguardando_confirmacao_do_prof_auxiliar = 0;
          }

          return auxiliar_atual.aulas?.map((aula) => {
            if (aula?.situacao === this.$constants.situacoesAulasTexto.confirmada) {
              this.professores_auxiliares[index].total_de_aulas_confirmadas_do_prof_auxiliar += 1;
            }
            if (
              aula?.situacao === this.$constants.situacoesAulasTexto.aguardando ||
              aula?.situacao === "" ||
              aula?.situacao === null
            ) {
              this.professores_auxiliares[
                index
              ].total_de_aulas_aguardando_confirmacao_do_prof_auxiliar += 1;
            }
            return aula;
          });
        });
        if (this.$route.query.is_infantil_multi === "true") {
          this.listagemAulas = response.aulas.filter((aula) => aula.e_aula_infantil === 1);
        }
        if (this.$route.query.is_infantil_multi === "false") {
          this.listagemAulas = response.aulas.filter((aula) => aula.e_aula_infantil !== 1);
        }
        this.gestaoDeAula = response.payload.gestaoDeAula;
        this.relatorio = response.payload.relatorio;
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
      this.carregandoAulas = false;
    },
    async deletarAula(aula) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar esta aula?",
        confirmationCode: aula.id,
        confirmationMessage: `Por favor, digite <strong>${aula.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Solicitar deleção da Aula");
              try {
                await this.$services.aulasService.solicitarDelecao(aula);
                this.listagemAulas = this.listagemAulas.filter((item) => item.id !== aula.id);
                this.$toast.success("Solicitação de deleção criada com sucesso");
                this.loadData();
                this.$forceUpdate();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              small: true,
            },
          },
        ],
      });
    },
    recuperarAula(aula) {
      this.$modals.warn({
        title: "Atenção!",
        message: "Tem certeza que deseja recuperar esta aula?",
        confirmationCode: aula.id,
        confirmationMessage: `Por favor, digite <strong>${aula.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Recuperando a Aula");
              try {
                await this.$services.aulasService.recuperarAula(aula);
                this.$toast.success("Aula recuperada com sucesso");
                this.$forceUpdate();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              small: true,
            },
          },
        ],
      });
    },
    async verHistoricoAulas() {
      this.openDrawer = !this.openDrawer;
    },
    async RelatorioBNCCTurma() {
      try {
        this.$loaderService.open("Carregando relátorio");
        await this.$services.relatoriosService.relatorioBNCCTurma(
          parseInt(this.gestaoDeAula.turma.id, 10)
        );
        this.$loaderService.close();
      } catch (error) {
        this.$loaderService.close();
        this.$handleError(error);
      }
    },

    async confirmarFrequencia() {
      this.$refs.modalConfirmacao.setLoading(true);
      try {
        await this.$services.aulasService.confirmarFrequencia(
          parseInt(this.aulaSelecionadaId, 10),
          this.removerFaltas
        );
        this.$toast.success("Frequência confirmada com sucesso");
        this.$router.push({ name: "aulas" });
      } catch (error) {
        this.$handleError(error);
        this.showConfirmacaoModal = true;
      } finally {
        await this.loadData();
        this.$refs.modalConfirmacao.setLoading(false);
      }
    },
    abrirModalConfirmacao(aula_id) {
      this.aulaSelecionadaId = aula_id;
      this.showConfirmacaoModal = true;
      this.removerFaltas = true;
    },
  },
};
</script>

<style></style>
